/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AzureVaultType } from '../models/AzureVaultType';

export class SnapshotLocation {
  /**
  * AWS snapshot ID or Azure restore point ID
  */
  'snapshotId': string;
  /**
  * AWS region or Azure location
  */
  'region': string;
  /**
  * Azure snapshot type (optional, for Azure only)
  */
  'snapshotType'?: SnapshotLocationSnapshotTypeEnum;
  /**
  * Azure vault name (optional, for vault-based snapshots)
  */
  'vaultName'?: string;
  /**
  * Azure vault resource group (optional, for vault-based snapshots)
  */
  'vaultResourceGroup'?: string;
  'vaultType'?: AzureVaultType | null;
  /**
  * Azure disk ID (optional, for Azure)
  */
  'diskId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "snapshotId",
      "baseName": "snapshotId",
      "type": "string",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "snapshotType",
      "baseName": "snapshotType",
      "type": "SnapshotLocationSnapshotTypeEnum",
      "format": ""
    },
    {
      "name": "vaultName",
      "baseName": "vaultName",
      "type": "string",
      "format": ""
    },
    {
      "name": "vaultResourceGroup",
      "baseName": "vaultResourceGroup",
      "type": "string",
      "format": ""
    },
    {
      "name": "vaultType",
      "baseName": "vaultType",
      "type": "AzureVaultType",
      "format": ""
    },
    {
      "name": "diskId",
      "baseName": "diskId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SnapshotLocation.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum SnapshotLocationSnapshotTypeEnum {
  Compute = 'compute',
  RecoveryServices = 'recovery_services'
}

